export default (() => {
  const init = () => {
    const checkBoxId = 'toggle-menu-btn';
    const navigation = document.querySelector('.navigation');
    const checkbox = document.querySelector(`#${checkBoxId}`);

    if (checkbox) {
      checkbox.addEventListener('click', () => {
        if (!checkbox.classList.contains('-active')) {
          checkbox.classList.add('-active');
          document.body.classList.add('nav-open');
          navigation.classList.add('navigation--open');
        } else {
          document.body.classList.remove('nav-open');
          checkbox.classList.remove('-active');
          navigation.classList.remove('navigation--open');
        }
      });
    }
  };

  return {
    init,
  };
})();
